import gql from 'graphql-tag'
import { PARTNERS_FRAGMENT } from './partnersFragment'
import { ELEMENT_SEO_FIELDS } from './seoQuery'
import { VIDEO_FILEDS } from './videoFragment'

export const ABOUT = gql`
  query about(
    $where: ElementWhereInput!
    $videoWhere: SettingPlusWhereUniqueInput!
    $partnersWhere: ElementWhereInput
    $partnersFirst: Int
  ) {
    element: element(where: $where) {
      id
      code
      name
      detailText
      previewText
      detailPicture {
        url
      }
      propertyValues {
        property {
          code
        }
        values
        descriptions
      }

      ...elementSeoFields
    }
    video: settingPlus(where: $videoWhere) {
      ...video_fields
    }
    partners: elements(
      where: $partnersWhere
      first: $partnersFirst
      order: { sort: asc }
    ) {
      edges {
        node {
          ...partnersFragment
        }
      }
    }
  }
  ${ELEMENT_SEO_FIELDS}
  ${VIDEO_FILEDS}
  ${PARTNERS_FRAGMENT}
`
